import Form         from '../../../Lib/Forms/Form';
import AuthResource from "../ApiResources/AuthResource";

export default class ResetPasswordForm extends Form {

    constructor(token) {
        super();
        this.token = token;
        this.email = '';
        this.password = '';
        this.passwordConfirm = '';
    }

    rules() {
        return {
            email          : ['required', 'email'],
            password       : ['required'],
            passwordConfirm: ['required'],
        }
    }

    submit() {
        let credentials = {
            token                : this.token,
            email                : this.email,
            password             : this.password,
            password_confirmation: this.passwordConfirm
        };

        return new AuthResource().resetPassword(credentials);
    }


}
